import React from "react";
import { Link } from "react-router-dom";
import "./ServicesCapabilities.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";
import { useServicesSection } from "../../../../context/ServicesPageContext";
import { getServiceCardsFromSection } from "../../../../services/contentApi";

import icon1 from "../../../../assets/icons/capabilities/icon1.svg";
import icon2 from "../../../../assets/icons/capabilities/icon2.svg";
import icon3 from "../../../../assets/icons/capabilities/icon3.svg";
import icon4 from "../../../../assets/icons/capabilities/icon4.svg";
import icon5 from "../../../../assets/icons/capabilities/icon5.svg";
import icon6 from "../../../../assets/icons/capabilities/icon6.svg";

const icons = [icon1, icon2, icon3, icon4, icon5, icon6];

const ServicesCapabilities = () => {
  const { section, loading } = useServicesSection("services-capabilities");

  if (loading || !section?.fields) return null;

  const fields = section.fields;
  const cards = getServiceCardsFromSection(section);

  return (
    <section className="servicescap">
      <div className="servicescap-top">
        {fields.subtitle ? (
          <CmsText content={fields.subtitle} as="p" />
        ) : null}
        {fields.title ? (
          <CmsText content={fields.title} as="h2" />
        ) : null}
        {fields.description ? (
          <RichTextContent content={fields.description} />
        ) : null}
      </div>

      <div className="servicescap-grid">
        {cards.map((card, i) => {
          const cardBody = (
            <>
              <div className="icon">
                <img src={icons[i]} alt="" />
              </div>

              <div>
                <CmsText content={card.category} as="p" className="category" />
                <CmsText content={card.title} as="h3" />
              </div>

              <RichTextContent content={card.description} className="desc" />

              <ul>
                {card.items.map((item, index) => (
                  <li key={index}>
                    <span className="dot"></span>
                    <CmsText content={item} as="span" />
                  </li>
                ))}
              </ul>

              {(card.buttonText || card.buttonLink) ? (
                <div className="svcapbutonholder">
                  <span className="learn-btn buttonclip">
                    <CmsText
                      content={card.buttonText || "Learn more"}
                      as="span"
                    />
                  </span>
                </div>
              ) : null}
            </>
          );

          if (card.buttonLink) {
            return (
              <Link
                key={i}
                to={card.buttonLink}
                className={`service-card ${card.highlight ? "highlight" : ""}`}
              >
                {cardBody}
              </Link>
            );
          }

          return (
            <div
              key={i}
              className={`service-card ${card.highlight ? "highlight" : ""}`}
            >
              {cardBody}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ServicesCapabilities;
